'use strict';

class UnBilledTransactions {
  constructor(billingService) {
    this.billingService = billingService;
  }

  $onInit() {
    this.list = [];

    this.load();
  }

  load() {
    this.billingService.unbilled()
      .then((resp) => {
        this.list = resp.data;
      });
  }
}

UnBilledTransactions.$inject = ['billingService'];

const unBilledTransactions = {
  controller: UnBilledTransactions,
  template: `
    <h2>Forbruk denne måneden</h2>
    <p>Dette vil bli fakturert den 1. i neste måned. Alle priser er eks. MVA.</p>

    <table>
      <thead>
        <tr>
          <th>Tidspunkt</th>
          <th>Fakturanummer</th>
          <th>Produkt</th>
          <th>Kunde</th>
          <th class="right-align">Pris</th>
          <th class="right-align">Rabatt</th>
          <th class="right-align">Kostnad</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="item in $ctrl.list track by $index">
          <td class="nowrap">{{ item.transactionTime | dateFormat:true }}</td>
          <td><a href="#/regning/{{ item.invoiceNumber }}">{{ item.invoiceNumber }}</a></td>
          <td>{{ item.description }}</td>
          <td><a href="#/kunde/{{ item.recipient.number }}">{{ item.recipient.name }}</a></td>
          <td class="nowrap right-align">{{ item.total | crowns }}</td>
          <td class="nowrap right-align">{{ item.discount }}%</td>
          <td class="nowrap right-align">{{ item.cost | crowns }}</td>
        </tr>
      </tbody>
    </table>
  `
};

angular
  .module('SendRegning')
  .component('unBilledTransactions', unBilledTransactions)
  .config(($routeProvider) => {
    $routeProvider
      .when('/konto/forbruk', {
        title: 'Forbruk denne måneden',
        template: '<un-billed-transactions />',
        secure: true
      });
  });
